import { IndexRateType } from '@willow/graphql-iso/src/app';

import { assertNever } from './assertNever';

export const formatIndexRateType = (type: IndexRateType) => {
  switch (type) {
    case IndexRateType.Sofr_30D:
      return 'SOFR 30-Day Average';
    case IndexRateType.Sofr_90D:
      return 'SOFR 90-Day Average';
    case IndexRateType.Sofr_180D:
      return 'SOFR 180-Day Average';
    case IndexRateType.Us_1M:
      return 'US Treasury 1-Month';
    case IndexRateType.Us_3M:
      return 'US Treasury 3-Month';
    case IndexRateType.Us_6M:
      return 'US Treasury 6-Month';
    case IndexRateType.Us_1Y:
      return 'US Treasury 1-Year';
    case IndexRateType.Us_3Y:
      return 'US Treasury 3-Year';
    case IndexRateType.Us_5Y:
      return 'US Treasury 5-Year';
    case IndexRateType.Us_10Y:
      return 'US Treasury 10-Year';
    case IndexRateType.WsjPrime:
      return 'WSJ Prime Rate';
    default:
      assertNever(type);
  }
};
